import { useTranslation } from 'next-i18next'
import { DRAWER_ORDER_DETAILS_KEY } from 'modules/drawer/state/drawer-types'
import { StyledToggle } from './order-details-drawer-toggle.styled'
import useDrawer from 'modules/drawer/state/use-drawer'

const OrderDetailsDrawerToggle = () => {
  const { t } = useTranslation()

  const drawer = useDrawer()

  const isOpen = drawer.current?.key === DRAWER_ORDER_DETAILS_KEY

  const onToggle = () => {
    if (isOpen) {
      drawer.close()
    } else {
      drawer.open(DRAWER_ORDER_DETAILS_KEY)
    }
  }

  return (
    <StyledToggle onClick={onToggle}>
      {isOpen
        ? t('orderDetailsDrawerToggle.closeButton.label', 'Close')
        : t('orderDetailsDrawerToggle.viewButton.label', 'View')}{' '}
      {t('orderDetailsDrawerToggle.donationDetails.label', 'donation details')}
    </StyledToggle>
  )
}

export default OrderDetailsDrawerToggle
